import React, { useState } from "react";
import styles from "./login.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../AxiosInstance";
import Loader from "../../components/loader/loader";
import { setCompanyTimezone } from "../../utils/utils";
import { setRole } from "../../utils/roles";
import { useTranslation } from 'react-i18next';

export default function Login() {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = () => {
    if (!loading) {
      setShowError(false);
      setLoading(true);
      axiosInstance
        .post("login/", { username, password })
        .then((response) => {
          localStorage.clear();
          if (response?.status !== 200) {
            setShowError(true);
            return;
          }
          localStorage.setItem("access", response.data.access);
          localStorage.setItem("refresh", response.data.refresh)
          localStorage.setItem("first_name", response.data.first_name);
          localStorage.setItem("last_name", response.data.last_name);
          localStorage.setItem("image", response.data.image);
          localStorage.setItem("has_imu", response.data.has_imu);
          setRole(response.data.role);
          setCompanyTimezone(response.data.company_timezone);
          window.location.replace("/");
        })
        .catch(() => {
          setShowError(true);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className={styles.container}>
      {loading && <Loader />}
      <div className={styles.leftSide}>
        <img
          src={"/branding/PRITECH_ISOTIPO_BLANCO.png"}
          alt={"pritech"}
          className={styles.leftSideLogo}
        />
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.loginContainer}>
          <img
            src={"/branding/PRITECH_COLOR.png"}
            alt={"pritech logo"}
            style={{ width: "100%", maxWidth: "362px" }}
          />

          <div className={styles.inputField}>
            <div className={"d-flex align-items-center mb-2"}>
              <FontAwesomeIcon
                className={"pe-2"}
                icon={faEnvelope}
                color={"#0B101E"}
              />
              <div style={{ fontSize: "13px", color: "#0B101E" }}>{t('login.email')}</div>
            </div>
            <input
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
          </div>

          <div className={styles.inputField}>
            <div className={"d-flex align-items-center mb-2"}>
              <FontAwesomeIcon
                className={"pe-2"}
                icon={faLock}
                color={"#0B101E"}
              />
              <div style={{ fontSize: "13px", color: "#0B101E" }}>
                {t('login.password')}
              </div>
            </div>
            <input
              type={"password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  submit();
                }
              }}
            />
          </div>

          {showError && (
            <div
              style={{
                color: "#F00",
              }}
            >
              {t('login.error')}
            </div>
          )}

          <div className={"mt-5"}>
            <div className={styles.loginButton} onClick={submit}>
              <div>{t('login.submit')}</div>
            </div>

            <a
              href={process.env.REACT_APP_PASSWORD_RESET_URL || "/accounts/password_reset/"}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.forgotPassword}
            >
              {t('login.forgotPassword')}
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}
